import { AccessTokenExpiredError, EmailAlreadyValidatedError, EmailInUseError, InvalidCredentialsError, InvalidEmailValidationTokenError, InvalidFileTypeError, NotFoundError, RateLimitError, RefreshTokenExpiredError, RefreshTokenInvalidError, UnexpectedError, } from "@for-it/domain-lib";
import { AccountDisabledError } from "./errors/account-disabled.js";
import { ApplicantNotFoundError } from "./errors/applicant-not-found.js";
import { ApplyToPublicationAlreadyExists } from "./errors/apply-to-publication-already-exists.js";
import { AssignmentNotFound } from "./errors/assignment-not-found.js";
import { CertificationAlreadyExistsError } from "./errors/certification-already-exists.js";
import { CertificationNotApproved } from "./errors/certification-not-approved.js";
import { CertificationNotFoundError } from "./errors/certification-not-found.js";
import { CertificationUserNotFoundError } from "./errors/certification-user-not-found.js";
import { CompanyNotFoundError } from "./errors/company-not-found.js";
import { DniInUseError } from "./errors/dni-in-use-error.js";
import { PasswordRepeatError } from "./errors/password-repeat-error.js";
import { PublicationNotFoundError } from "./errors/publication-not-found.js";
import { TagAlreadyExistsError } from "./errors/tag-already-exists-error.js";
export const DomainErrors = {
    UnexpectedError: UnexpectedError,
    InvalidCredentialsError: InvalidCredentialsError,
    EmailInUseError: EmailInUseError,
    RateLimitError: RateLimitError,
    EmailAlreadyValidatedError: EmailAlreadyValidatedError,
    InvalidEmailValidationTokenError: InvalidEmailValidationTokenError,
    RefreshTokenExpiredError: RefreshTokenExpiredError,
    RefreshTokenInvalidError: RefreshTokenInvalidError,
    NotFoundError: NotFoundError,
    InvalidFileTypeError: InvalidFileTypeError,
    DniInUseError: DniInUseError,
    PublicationNotFoundError: PublicationNotFoundError,
    CertificationUserNotFoundError: CertificationUserNotFoundError,
    CompanyNotFoundError: CompanyNotFoundError,
    ApplicantNotFoundError: ApplicantNotFoundError,
    AccessTokenExpiredError: AccessTokenExpiredError,
    TagAlreadyExistsError: TagAlreadyExistsError,
    CertificationNotFoundError: CertificationNotFoundError,
    PasswordRepeatError: PasswordRepeatError,
    CertificationAlreadyExistsError: CertificationAlreadyExistsError,
    ApplyToPublicationAlreadyExists: ApplyToPublicationAlreadyExists,
    AccountDisabledError: AccountDisabledError,
    AssignmentNotFound: AssignmentNotFound,
    CertificationNotApproved: CertificationNotApproved,
};
